import * as dictActions from 'redux_store/modules/dictionary/dictionary';
import * as cardActions from 'redux_store/modules/tenderCard';
import { getVarible } from 'redux_store/modules/global';

const promises = (inject, dispatch, zoneId, tenderId, state) => [
  dispatch(getVarible()).catch(() => null),
  dispatch(dictActions.loadUser(zoneId)).catch(() => null),
  dispatch(dictActions.loadZoneStatus(zoneId)).catch(() => null),
  dispatch(cardActions.getStatusOwner(tenderId)).catch(() => null),
  dispatch(cardActions.loadSubscribe(tenderId)).catch(() => null),
  dispatch(cardActions.userAccessGet(tenderId)).catch(() => null),
  dispatch(dictActions.loadDepartament(zoneId)).catch(() => null),
  !dictActions.isCurrencyLoaded(state) ? dispatch(dictActions.loadCurrency()).catch(() => null) : Promise.resolve(),
  !dictActions.isPlacingWayLoaded(state) ? dispatch(dictActions.loadPlacingWay()).catch(() => null) : Promise.resolve(),
  !dictActions.isPurchaseTypeLoaded(state)
    ? dispatch(dictActions.loadPurchaseType()).catch(() => null)
    : Promise.resolve(),
  !dictActions.isGridSortLoaded(state) ? dispatch(dictActions.loadGridSort()).catch(() => null) : Promise.resolve(),
  !dictActions.isRegionLoaded(state) ? dispatch(dictActions.loadRegion()).catch(() => null) : Promise.resolve(),
  !dictActions.isUserDependencyLoaded(state)
    ? dispatch(dictActions.loadUserDependency(zoneId)).catch(() => null)
    : Promise.resolve(),
];
module.exports = promises;
